<template>
  <b-card no-body>
    <b-card-img v-if="prize.image && typeof prize.image.fileLocation === 'string'" class="img-fit-cover mx-auto"
      :src="prize.image.fileLocation" :alt="prize.title" height="256" width="256"/>

    <b-card-header class="bg-white border-0 p-1 px-sm-2" v-if="!raffleMode">
      <slot name="position"><h4>&nbsp;</h4></slot>
      <slot name="held-by"><p class="m-0">&nbsp;</p></slot>
    </b-card-header>

    <b-card-body class="bg-white border-0 px-1 px-sm-3">
      <p class="my-1"><strong>{{ prize.title }}</strong></p>
      <p class="my-1" v-if="!hideDescriptions && prize.description">{{ prize.description }}</p>
    </b-card-body>

    <b-card-footer class="bg-white border-0 px-sm-3" v-if="prize.terms">
      <b-btn size="sm" variant="transparent" v-b-modal="`${modalID}-terms`">View T&amp;C's</b-btn>
      <b-modal :id="`${modalID}-terms`" title="Terms &amp; Conditions" hide-footer>
        <p class="my-1 text-muted"><em>{{ prize.terms }}</em></p>
      </b-modal>
    </b-card-footer>
  </b-card>
</template>

<script>
export default {
  props: {
    prize: {
      type: Object,
      required: true,
    },
    raffleMode: {
      type: Boolean,
      default: () => false,
    },
    hideDescriptions: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    modalID() {
      return `prize-${this._uid}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/leaderboards/Prize-Item.vue